import axios from 'axios';

export const getCancelSource = () => axios.CancelToken.source();
